import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { AMBOSS_HELP_LINKS } from './amboss.config';
import { AmbossPanel } from './amboss.styles';

export function AmbossHelpOverlay() {
  const { t } = useTranslation();
  return (
    <AmbossPanel>
      <ul aria-label={t('amboss.help.title')} className="flex flex-col">
        {AMBOSS_HELP_LINKS.map((link) => (
          <li key={link.url}>
            <a
              data-ph-no-autocapture
              href={link.url}
              target="_blank"
              rel="noreferrer noopener"
              className="flex cursor-pointer items-center justify-between -mx-2 rounded-md px-2 py-4 text-vantis-violet underline hover:bg-muted"
            >
              <span>{t(link.labelKey)}</span>
              <ExternalLink size={18} aria-hidden />
            </a>
          </li>
        ))}
      </ul>
    </AmbossPanel>
  );
}
